<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <!-- <a-col :md="6" :sm="24">
            <a-form-item label="预测名称：">
              <global-select
                @change="handleNameChange"
                :value.sync="queryParams.forecastName"
                selectType="select"
                requestApi="/scp/salesForecast/forecastNamePullDown"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col> -->
          <!-- <a-col :md="6" :sm="24">
            <a-form-item label="预测起始月">
              <a-input v-model="queryParams.startMonth"/>
            </a-form-item>
          </a-col> -->
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                @change="handleVersionChange"
                :value.sync="queryParams.versionCode"
                :setParams="{monthStart:monthStart, monthEnd:monthEnd}"
                selectType="selectSearch"
                searchParam="no"
                requestApi="/scp/sopRatioHead/versionCodePullDown"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <template>
            <a-col :md="6" :sm="24">
              <a-form-item label="版本说明">
                <a-input :disabled="true" v-model="queryParams.description"/>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="24">
            <a-form-item label="供应类型">
              <a-select show-search mode="multiple" :filter-option="filterOption" option-filter-prop="children" v-model="queryParams.supplyType" >
                <a-select-option v-for="(item) in supplyTypeOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item v-if="advanced" label="下单类别">
              <a-select show-search mode="multiple" option-filter-prop="children" v-model="queryParams.scpOrderType" >
                <a-select-option v-for="(item) in scpOrderTypeOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item v-if="advanced" label="安全库存类别">
              <a-select show-search mode="multiple" option-filter-prop="children" v-model="queryParams.scpSopClassify" >
                <a-select-option v-for="(item) in classifyOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleOnSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleExport" type="primary" v-hasPermi="['scp:sopRatioLines:export']">导出</a-button>
      <a-button @click="$refs.importData.show()" type="primary" v-hasPermi="['scp:sopRatioLines:import']">导入</a-button>
      <a-button @click="handleTemplate" v-hasPermi="['scp:sopRatioLines:template']">下载模版</a-button>

    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-spin :spinning="isLoading">
          <ls-api-table
            ref="dataTable"
            :columns="columns"
            :tableProps="tableProps"
            rowKey="id"
            :scroll="{ fixScreen: true, x: 1300 }"
          >
            <span slot="operation" slot-scope="{ record,index }">
              <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record,index)" v-hasPermi="['scp:sopRatioLines:edit']">编辑</a>
              <a v-if="!isEdit || currentId !== record.id" class="ml10" @click="handleDeleteAlert(typeList, record)" v-hasPermi="['scp:sopRatioLines:remove']">删除</a>
              <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
              <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
            </span>
            <!-- 物料编码 -->
            <template slot="itemCode" slot-scope="{ record }">
              <span v-if="!isEdit || currentId !== record.detailId">{{ record.itemCode }}</span>
              <a-input v-if="isEdit && currentId === record.detailId" v-model="record.itemCode" size="small" />
            </template>

            <!-- 月份 -->
            <template slot="month" slot-scope="{ record, column }">
              <span v-if="!isEdit || currentId !== record.id">{{ record[column.dataIndex].scpSopRatio+ '%' }}</span>
              <a-input-number
                :min="0"
                v-if="isEdit && currentId === record.id"
                v-model="record[column.dataIndex].scpSopRatio"
                size="small"
              />
              <!-- <a-button @click="handlerTestClick(record, column)"> 测试</a-button>  @change="handleInputChange(record,column.dataIndex)"-->
            </template>

            <template slot="isStopFlag" slot-scope="{ record }">
              <span >{{ record.isStopFlag === 'Y' ? '是' : '否' }}</span>
            </template>

          <!-- <div
            v-for="item in monthColumns1"
            :slot="item.dataIndex"
            slot-scope="{record}"
            :key="item.dataIndex"
          >
            <a-input v-model="record.versionCode"></a-input>
          </div> -->
          </ls-api-table>
        </a-spin>
        <import-data
          ref="importData"
          :url="url"
          :sopDfcBasicDataId="queryParams.versionCode"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

  <script>
  import { generateLsTableResData } from '@/utils/util.js';
  import { apiUpdateSopRatioLines, apiSopRatioLinesList, apiDelSopRatioLines } from '@/api/scp/general-parameter-settings/safety-stock-ratio.js'
  import ImportData from './components/ImportData'

  export default {
    // eslint-disable-next-line
    name: 'detail', // name要和菜单路由保存一致; 新页面不要建这种容易重复的name
    components: {
      ImportData
    },
    data () {
      return {
        versionCode: '',
        monthStart: '',
        monthEnd: '',
        url: '/scp/sopRatioLines/import',
        supplyTypeOptions: [],
        scpOrderTypeOptions: [],
        classifyOptions: [],
        monthColumns1: [
          {
            title: '版本',
            width: 140,
            fixed: 'left',
            dataIndex: 'month0',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '版本说明',
            fixed: 'left',
            dataIndex: 'month1',
            scopedSlots: { customRender: 'versionDescription' },
            width: 140,
            align: 'center'
          }
        ],
        monthColumns: [],
        isSetTitle: false,
        // 表格配置
        tableProps: {
          requestApi: generateLsTableResData(apiSopRatioLinesList, true),
          pageCurrent: true
        },
        isEdit: false,
        currentId: "",
        // 控制搜索展开
        advanced: true,
        isLoading: false,
        // 查询参数
        queryParams: {
          // 预测名称
          forecastName: undefined,
           // 版本
          versionCode: undefined,
          startMonth: undefined,
          versionDescription: undefined,
          supplyType: undefined,
          scpOrderType: undefined,
          scpSopClassify: undefined
        },
        // 表格多选
        selectedRowKeys: [],
        selectedRows: [],
        // 状态快码
        statusOptions: [
          {
            dictLabel: "有效",
            dictValue: "Y"
          },
          {
            dictLabel: "无效",
            dictValue: "N"
          }
        ],
        baseUomFlagOptions: [
          {
            dictLabel: "是",
            dictValue: "Y"
          },
          {
            dictLabel: "否",
            dictValue: "N"
          }
        ],
        // 表格字段
        columnsNative: [
          {
            title: '供应类型',
            dataIndex: 'supplyTypeName',
            width: 100,
            align: 'center'
          },
          {
            title: '下单类别',
            dataIndex: 'scpOrderTypeName',
            ellipsis: true,
            width: 100,
            align: 'center'
          },
          {
            title: '安全库存类别',
            dataIndex: 'scpSopClassifyName',
            ellipsis: true,
            width: 100,
            align: 'center'
          },
            {
            title: '操作',
            width: 140,
            fixed: 'right',
            align: 'center',
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' }
            }
        ],
        columns: [],
        unitOfMeasureList: [],
        unitOfMeasureListNew: []
      }
    },
    created () {
      this.queryParams.forecastName = this.$route.query.forecastName;
      this.queryParams.versionCode = this.$route.query.versionCode;
      this.queryParams.description = this.$route.query.description;
      this.versionCode = this.$route.query.versionCode;
      this.description = this.$route.query.description;
      this.monthEnd = this.$route.query.monthEnd;
      this.monthStart = this.$route.query.monthStart;

       this.columns = this.columnsNative
       const lookupQueryParams = {
            lookupType: 'SCP_ORDER_CATEGORY',
            current: 1,
            pageSize: 100
        }
        this.getLookupListData(lookupQueryParams).then().then(response => {
        this.scpOrderTypeOptions = response.rows
        })
        const lookupQueryClassifyParams = {
            lookupType: 'SCP_SINV_CLASSIFY',
            current: 1,
            pageSize: 100
        }
        this.getLookupListData(lookupQueryClassifyParams).then().then(response => {
        this.classifyOptions = response.rows
        })

        const lookupQuerySupplyTypeParams = {
            lookupType: 'SCP_FG_SUPPLY_TYPE',
            current: 1,
            pageSize: 100
        }
        this.getLookupListData(lookupQuerySupplyTypeParams).then().then(response => {
        this.supplyTypeOptions = response.rows
        })
    },
    mounted () {
      this.onSearch()
    },
    methods: {
      // 手动输入
      filterOption (input, option) {
        return option.componentOptions.children[0].text.toLowerCase().trim().indexOf(input.toLowerCase().trim()) >= 0
      },
            /** 下载模板操作 */
      handleTemplate () {
        this.download('scp/sopRatioLines/template', { versionCode: this.queryParams.versionCode
        }, `安全库存比例行导入模板_${new Date().getTime()}.xlsx`)
      },
      handleOnSearch () {
        this.isSetTitle = false
        this.onSearch()
      },
      handleInputChange (record, dataIndex) {
        // debugger
      },
      successCallBack (records) {
          // 遍历行数据
          for (let i = 0; i < records.length; i++) {
            const record = records[i]
            const detailVoList = records[i].detailVoList
            this.monthColumns = []
              for (let i = 0; i < detailVoList.length; i++) {
                if (!self.isSetTitle) {
                    const title = detailVoList[i].month
                    this.monthColumns.push({
                      title: title,
                      dataIndex: `month${i}`,
                      width: 120,
                      align: 'center',
                      scopedSlots: { customRender: `month` }
                    })
                 }
                 // record[`month${i}`] = detailVoList[i].salesForecast
                 const propertyName = `month${i}`;
                  const propertyValue = detailVoList[i].salesForecast;
                  this.$set(record, propertyName, propertyValue);
            }

              if (!this.isSetTitle) { // 把数据插入到指定位置
                // 使用扩展运算符
                const columnsCopy = [...this.columnsNative];
                columnsCopy.splice(9, 0, ...this.monthColumns);
                this.columns = columnsCopy;
              }
              this.isSetTitle = true
          }
      },
      handleDeleteAlert (tableList, record) {
        const self = this
        this.$confirm({
        title: '警告',
        content: `真的要删除该项的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          self.handleDelete(tableList, record)
        }
      })
      },
      handleDelete (tableList, record) {
        // const param = {
        //   itemId: record.itemId,
        //   versionCode: record.versionCode,
        //   lookupCode: record.lookupCode
        // }
        apiDelSopRatioLines(record).then(response => {
        if (response.code === 200) {
          this.$message.success('删除成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
      },
      handleOperation (text, record) {
        this.$router.push({ path: `/salesForecast/detail/` })
      },
      handleNameChange (val, selectList) {
        const filteredItem = selectList.filter(item => item.realValue === val);
        this.queryParams.startMonth = filteredItem[0].bringOutDataOne
      },
      handleVersionChange (val, selectList) {
        if (val) {
          const filteredItem = selectList.filter(item => item.realValue === val);
          this.queryParams.description = filteredItem[0].bringOutDataOne
          this.queryParams.forecastName = filteredItem[0].bringOutDataOne
          this.description = filteredItem[0].bringOutDataOne;
        }
      },
      blur (record) {
        if (!record.conversionRate || Number(record.conversionRate) <= 0) {
          this.$message.warning('折换不能为空且需大于0')
        } else {
          record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
        }
      },
      statusOnChange (record) {
        record.status = record.status === 'Y' ? 'N' : 'Y'
      },
      // 导入导出excel
      /** 导出按钮操作 */
      handleExport () {
        this.download('scp/sopRatioLines/export', {
          ...this.queryParams
        }, `安全库存比例列表_${new Date().getTime()}.xlsx`)
      },
      // 编辑
      handleEdit (record, index) {
        if (this.currentId && record.id !== this.currentId && this.isEdit) {
          this.$message.warning('请保存上次编辑的数据')
          return;
        }
        this.isEdit = true;
        this.currentId = record.id;
      },
      // 编辑-保存
      handleSave (record) {
      // const recordCopy = JSON.parse(JSON.stringify(record));
      // const detailVoList = recordCopy.detailVoList
      // for (let i = 0; i < detailVoList.length; i++) {
      //    const detailVoItem = detailVoList[i]
      //    detailVoItem.salesForecast = recordCopy[`month${i}`]
      // }
      let isNoEdit = false
        let title = ''
        for (const key in record) {
            if (key.includes('month') && (record[key].scpSopRatio === '' || record[key].scpSopRatio === undefined || record[key].scpSopRatio === null)) {
              isNoEdit = true
              const foundItem = this.columnsServe.find(item => item.indexKey === key);
              title = title + foundItem.indexName + ','
          }
        }
        if (isNoEdit) {
            this.$message.error(title + '列为空，保存失败')
            return
          }
      apiUpdateSopRatioLines(record).then(response => {
        if (response.code === 200) {
          this.$message.success('更新成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
      },
      // 取消
      handleCancel (record) {
        this.isEdit = false
        this.onSearch()
      },
      // 新增/修改框事件
      handleOk () {
        this.onSearch()
      },
      // 表单搜索
      onSearch () {
        this.isEdit = false
       this.$refs.dataTable.searchParams = this.queryParams;
      // this.$refs.dataTable.getData();
      this.$refs.dataTable.myPagination.current = 1
      this.getTableInfo({ ...this.queryParams, pageSize: this.$refs.dataTable.myPagination.pageSize, pageNum: 1 })
      },
      /** 重置按钮操作 */
      resetQuery () {
        this.isSetTitle = false
        this.queryParams = {
          versionCode: this.queryParams.versionCode,
          description: this.queryParams.description,
          unitOfMeasureList: undefined,
          forecastName: undefined,
           // 版本
          startMonth: '',
          versionDescription: '',
          supplyType: undefined,
          scpOrderType: undefined,
          scpSopClassify: undefined
        }
        // this.queryParams.description = 'ABC';
        this.onSearch()
      },
      // 搜索框展开、收起
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
          /**
     * 在table 某个列的字段后增加列
     * key：列的字段名称
     * columnList 列表的列
     * insertColumnList 插入的新列
     *  */
    setNewColumn (key, columnList, insertColumnList) {
      const newArray = [...columnList] // 创建新的数组，保持原始数据的不变
      const index = newArray.findIndex((item) => item.dataIndex === key) // 找到具有indexKey值为'kk'的对象的索引位置
      if (index !== -1) {
        newArray.splice(index + 1, 0, ...insertColumnList) // 在索引位置后面插入新数组
      }
        return newArray
      },
      getTableInfo (Params) {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      apiSopRatioLinesList(Params).then((response) => {
        this.isLoading = false
        if (response.code === 200) {
          this.tableList = response.rows
          this.tableList.forEach((obj, index) => {
            obj.id = index + 1 // 生成唯一的ID，可以使用索引值加上 1
          })
          this.$refs.dataTable.myDataSource = this.tableList
          const titles = response.title
          this.columnsServe = response.title
          // 生成新的对象数组，并为每个对象添加name属性
          const newArray = titles.map((title) => {
            return {
              title: title.indexName,
              dataIndex: title.indexKey,
              scopedSlots: { customRender: 'month' },
              width: 120,
              align: 'center'
            }
          })
          const dynamicColumn = this.setNewColumn('scpSopClassifyName', this.columnsNative, newArray)
          this.columns = dynamicColumn
          this.$refs.dataTable.myPagination.total = response.total
          this.$refs.dataTable.pageTotal = this.$refs.dataTable.getPageTotal(response.total, this.$refs.dataTable.myPagination.pageSize)
        } else {
          this.tableList = []
            this.$refs.dataTable.myDataSource = this.tableList
          this.$message.error(response.msg)
        }
      }).catch((error) => {
        this.isLoading = false
        // 处理 API 调用失败的情况
        console.error('API 调用失败: ', error);
      })
    }
    }
  }
  </script>

  <style scoped lang="less">
  .ml10{
    margin-left: 10px;
  }
  </style>
